import { Alert, Button, Stack, CircularProgress } from "@mui/material";
import useDealBuilderAlertsStore from "../../stores/deal-builder-alerts.store.ts";
import { DealBuilder } from '../services/deal-builder.ts';
import useDealBuilderSimilarDealsStore from "../../stores/deal-builder-similar-deals.store.ts";
import { SimilarDealsList } from "./similar-deals-page/similar-deals-list.tsx";
import SimilarDealsTable from "./similar-deals-page/similar-deals-table.tsx";

interface SimilarDealsPageProps {
  builder: DealBuilder
}

export default function SimilarDealsPage({ builder }: SimilarDealsPageProps) {
  const { hiddenSimilarDealsAlert, setHiddenSimilarDealsAlert } = useDealBuilderAlertsStore();
  const { loading, starredSimilarDealCusips } = useDealBuilderSimilarDealsStore();

  return (
    <Stack direction="column" gap={2} margin={2} sx={{ width: "100%" }}>
      {!hiddenSimilarDealsAlert && starredSimilarDealCusips.length === 0 && (
        <Alert
          severity="info"
          action={
            <Button
              color="inherit"
              size="small"
              onClick={() => setHiddenSimilarDealsAlert(true)}
            >
              Hide
            </Button>}
        >
          You can star deals to save them along the deal.
        </Alert>
      )}

      {loading ? (
        <Stack 
          direction="column" 
          alignItems="center"
          justifyContent="center"
          sx={{ height: "100px" }}
        >
          <CircularProgress />
        </Stack>
      ): (
        <Stack 
          direction="column"
          gap={2}
        >
          <SimilarDealsList />
          <SimilarDealsTable builder={builder} />
        </Stack>
      )}
    </Stack>
  )

}
